export default "__VITE_ASSET__F6WN1xRs__"